// Exchange — toolbar (search · filter · sport segment · sort · view
// toggle). Pure presentation; the page owns the state and passes
// callbacks. Visually matches the prototype's `.ex-toolbar` shell.

import { Icon } from "../../components/icons/Icon.tsx";
import type { SortKey } from "./exchange-derive.ts";

interface Props {
  search: string;
  onSearch: (value: string) => void;
  filterCount: number;
  sort: SortKey;
  onSort: (key: SortKey) => void;
  view: "table" | "cards";
  onViewChange: (view: "table" | "cards") => void;
}

export function ExchangeToolbar(props: Props): JSX.Element {
  const { search, onSearch, filterCount, sort, onSort, view, onViewChange } = props;
  return (
    <div className="ex-toolbar">
      <div className="search">
        <Icon name="search" size={13} />
        <input
          placeholder="Search teams, leagues, or signal IDs…"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
        <span
          className="kbd"
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 11,
            color: "var(--text-tertiary)",
          }}
        >
          /
        </span>
      </div>
      <button className="filter-btn" type="button">
        <Icon name="settings" size={13} />
        Filters
        {filterCount > 0 ? <span className="badge-num">{filterCount}</span> : null}
      </button>
      <div className="seg">
        <button className="on" type="button">
          Football
        </button>
        <button title="Coming soon" disabled style={{ opacity: 0.5 }} type="button">
          Polymarket
        </button>
        <button title="Coming soon" disabled style={{ opacity: 0.5 }} type="button">
          Crypto
        </button>
      </div>
      <div className="right">
        <div className="sort">
          Sort
          <select value={sort} onChange={(e) => onSort(e.target.value as SortKey)}>
            <option value="edge">Edge (high → low)</option>
            <option value="conf">Confidence</option>
            <option value="kickoff">Kickoff (soonest)</option>
            <option value="prob">Agent probability</option>
          </select>
        </div>
        <div className="view-toggle">
          <button
            className={view === "table" ? "on" : ""}
            title="Table"
            type="button"
            onClick={() => onViewChange("table")}
          >
            <Icon name="audit" size={13} />
          </button>
          <button
            className={view === "cards" ? "on" : ""}
            title="Cards"
            type="button"
            onClick={() => onViewChange("cards")}
          >
            <Icon name="vault" size={13} />
          </button>
        </div>
      </div>
    </div>
  );
}
